import React, {createElement, Component} from "react";
import {WithPermission, Notification, translate} from "admin-on-rest";
import {connect} from "react-redux";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import CircularProgress from "material-ui/CircularProgress";
import Avatar from "material-ui/Avatar";
import "../../App.css";
import AppBar from "../CRM/AppBar";
import Sidebar from "../Sidebar";
import Menu from "../Menu/";
import GitInfo from "../../_git_info";
import layoutStyle from "./style";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import {upperFirst} from "lodash";
import {BMTheme} from "../../BMTheme";
import {getImagesSuccess as getImagesSuccessAction} from "../../actions/images";
import {giftCardsEnabled as giftCardsEnabledAction} from "../../actions/giftCards";
import {images} from "../../images/image-list";
import restClient from "../../restClient";

class DesktopLayout extends Component {
  state = {
    instanceName: "",
    giftCardEnabled: false
  };

  componentDidUpdate(nextProps) {
    if ( this.props.configuration !== nextProps.configuration && this.props.configuration.instance ){
      let instanceName = this.props.configuration.instance.name;
      this.setState({instanceName: instanceName});
      this.fetchImages(instanceName);
      this.fetchKiosk();
    }    
  }

  async fetchKiosk() {
    const ROLE = localStorage.getItem("role");
    if(ROLE === "partner"){
      const KIOSK = JSON.parse(localStorage.getItem("kiosk"));
      const KIOSK_ID = KIOSK ? KIOSK.id : '';
      
      try {
        const pagination = {page: 1, perPage: 10};
        const sort = {field: "name", order: "ASC"};
        const reference = `kiosks/${KIOSK_ID}`;

        restClient("GET_LIST", reference, {
          pagination: {...pagination},
          sort: sort,
          filter: ''
        }).then(response => {
          let kiosk_data = response && response.data;
          this.checkGiftCardEnabled(kiosk_data);
        });
      } catch (e) {
        console.error("error", e);
      }
    }    
  }

  checkGiftCardEnabled(kiosk){
    if (!kiosk.extra) {
      return
    }

    const gcEnabled = Object.values(kiosk.extra).some(partner => partner.gift_card_enabled);

    // seems something is reading using localstorage to transfer data.. also, setting state manually _and_ calling
    // action seems redundant
    if (gcEnabled) {
      this.props.giftCardsEnabled();
      this.setState({
        giftCardsEnabled: true
      });
      localStorage.setItem('kiosk_gift_card_enabled', true);
    } else {
      localStorage.setItem('kiosk_gift_card_enabled', false);
    }
  }

  async fetchImages(instanceName) {
    try {
      const INSTANCE_NAME = instanceName;
      let imageArray = [];

      for (let i = 0; i < images.length; i++) {
        let image = await fetch(
          `${process.env.REACT_APP_API_URL}/static/${INSTANCE_NAME}/crm/images/${images[i]}`,
          {
            method: "GET",
            headers: {
              Accept: "application/vnd.api+json",
              "Content-Type": "application/vnd.api+json"
            }
          }
        );
        imageArray.push(image);        
      }
      this.props.getImagesSuccess(imageArray);
    } catch (e) {
      console.error("error", e);
    }
  }

  render() {
    const userEmail = localStorage.getItem("email");
    const permissions = localStorage.getItem("role");
    const {
      children,
      dashboard,
      isLoading,
      logout,
      menu,
      title,
      translate
    } = this.props;

    const instanceName = upperFirst(this.state.instanceName);

    if(this.props.images){
      const images = this.props.images;

      var avatar = images.hasOwnProperty('avatar_logo') ? this.props.images.avatar_logo : '';
      var logo = images.hasOwnProperty('sidebar_logo') ? this.props.images.sidebar_logo : '';
    }

    var withPermissionLayout = null;
    if(permissions !== null){
      if(permissions === 'admin'){
        withPermissionLayout = <WithPermission value="admin">{children}</WithPermission>;
      } else if(permissions === 'partner'){
        withPermissionLayout = <WithPermission value="partner">{children}</WithPermission>;
      } else {
        withPermissionLayout = <WithPermission value="notAllowed">
          <div style={layoutStyle.content.withoutPermission}>
            <p>{translate("resources.noPermissiom.text")}</p>
          </div>
        </WithPermission>;
      }
    }

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(BMTheme)}>
        <div style={layoutStyle.main}>
          <Sidebar>
            <div style={layoutStyle.drawer}>
              <div style={layoutStyle.userContainer}>
                <div style={layoutStyle.avatar}>
                  <Avatar src={avatar} />
                </div>

                <div style={layoutStyle.userInfo}>
                  <p style={layoutStyle.userInfo.textStyle}>
                    {userEmail}
                    <br />
                  </p>
                </div>
              </div>

              <div style={layoutStyle.sidebar}>
                <div style={layoutStyle.sidebar.menu}>
                  {createElement(menu || Menu, {
                    logout,
                    hasDashboard: !!dashboard,
                    configuration: this.props.configuration
                  })}
                </div>
                <div style={layoutStyle.logo}>
                  <img src={logo} alt="" style={layoutStyle.logo.imageStyle} />
                  <p style={layoutStyle.logo.textStyle}>
                    {instanceName} v {GitInfo.version}
                  </p>
                </div>
              </div>
            </div>
          </Sidebar>

          <div style={layoutStyle.body}>
            <AppBar title={title} />

            {permissions !== null ? (
              <div style={layoutStyle.content}>
                {withPermissionLayout}
              </div>
            ) : (
              children
            )}
          </div>

          <Notification />
          {isLoading && (
            <CircularProgress
              color={BMTheme.palette.alternateTextColor}
              size={30}
              thickness={2}
              className="App"
              style={layoutStyle.loader}
            />
          )}
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    images: state.images
  };
}

const TranslatedDesktopLayout = translate(DesktopLayout);

const ShowDesktopLayout = connect(
  mapStateToProps,
  {
    getImagesSuccess: getImagesSuccessAction,
    giftCardsEnabled: giftCardsEnabledAction
  }
)(TranslatedDesktopLayout);


export default ShowDesktopLayout;



// WEBPACK FOOTER //
// ./src/components/Layout/DesktopLayout.js